import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpegToWebpConfig } from '@/data/landingConfig/landingJpegToWebpConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpegToWebp } from './schemaObject';

interface Props {}
const JpegToWebpConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpegToWebp} />
			<LandingTemplate
				data={landingJpegToWebpConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpegToWebpConverter;
